<template>
  <div class="app-single-topup-confirm">
    <slot name="txtBefore">
      <h2>Einmaliges Aufladen</h2>
      <p>
        Sie können die Aufladung nur mit Ihren hinterlegten Kreditkarten- oder Lastschriftinformationen nutzen.
        Ändern Sie <a href="#">hier</a> ggf. Ihre Zahlart.
        Klicken Sie auf "Jetzt aufladen",  um Ihr Guthaben aufzuladen.
      </p>
    </slot>
    <b-row class="single-topup-amount">
      <b-col cols="12" md=""><label><slot name="lblAmount">Aufzuladender Betrag</slot></label></b-col>
      <b-col cols="12" md=""><span class="amount">{{formattedAmount}}</span></b-col>
    </b-row>
    <b-row class="single-topup-payment-type" v-if="paymentType">
      <b-col cols="12" md=""><label><slot name="lblPaymentType">Ihre Zahlungsart:</slot></label></b-col>
      <b-col cols="12" md="">
        <span class="payment-type" v-if="isBankAccount">
          <slot name="lblTypeBank">Lastschrift</slot>
      </span>
        <span class="payment-type" v-if="isCreditCard">
          <slot name="lblTypeCredit">Kreditkarte</slot>
      </span>
      </b-col>
    </b-row>
    <slot name="lblPaymentInfo"></slot>
    <PaymentInformation :payment="payment">
      <template v-for="slot in possibleChildSlotsFor('Payment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PaymentInformation>
    <slot name="txtInfoChangePayment"></slot>
    <Stepper
      @prev="prev()"
      @next="next()"
      :loading-next="loading"
    >
      <template #btnPrev><slot name="btnPrev"></slot></template>
      <template #btnNext><slot name="btnNext"></slot></template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>

import processSteps from '../../../../../mixins/processSteps'
import { stepName as previousStep } from './AmountSelector.vue'
import { stepName as nextStep } from './Success.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Stepper from '../../../../generic/Stepper.vue'
import PaymentInformation from '../../Payment/PaymentInformation.vue'
import price from '@/mixins/price'
import slotProxy from '../../../../../mixins/slotProxy'

export const stepName = 'confirm'

export default {
  name: 'SingleTopUpConfirm',
  components: { PaymentInformation, Stepper },
  data () {
    return {
      loading: false
    }
  },
  mixins: [
    processSteps(stepName, previousStep, nextStep),
    price,
    slotProxy()
  ],
  computed: {
    ...mapGetters('topUp/single', [
      'amount'
    ]),
    formattedAmount: function () {
      return this.overwriteFormattedAmount || this.price(this.amount)
    },
    isCreditCard () {
      return this.payment.type === 'creditCard'
    },
    isBankAccount () {
      return this.payment.type === 'bankAccount'
    }
  },
  methods: {
    ...mapMutations('topUp/single', [
      'changeStep'
    ]),
    ...mapActions('topUp/single', [
      'performSingleTopUp'
    ]),
    prev () {
      this.changeStep({ step: this.previousStep })
    },
    async next () {
      this.loading = true
      await this.performSingleTopUp({ step: this.nextStep })
      this.loading = false
    }
  },
  props: {
    payment: {
      type: Object,
      required: true
    },
    paymentType: {
      type: Boolean,
      required: false
    },
    overwriteFormattedAmount: {
      type: String,
      default: null
    }
  }
}
</script>
